const RELOADED_KEY = "recobra:reloaded-after-stale-chunk";

/**
 * A tab left open across a deploy references chunk hashes purged from the
 * CDN; Vite's dynamic `import()` rejects with this message when that happens.
 */
export const isStaleChunkError = (error: unknown): boolean =>
  error instanceof Error &&
  /failed to fetch dynamically imported module|error loading dynamically imported module/i.test(
    error.message,
  );

export const hasReloadedForStaleChunk = (): boolean =>
  sessionStorage.getItem(RELOADED_KEY) === "true";

export const reloadForStaleChunk = (): void => {
  sessionStorage.setItem(RELOADED_KEY, "true");
  window.location.reload();
};
